import React from 'react';

import {useTranslation} from "react-i18next";

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Rotate90DegreesCcwIcon from '@mui/icons-material/Rotate90DegreesCcw';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {toRem} from "../../../../themes/utils";

const IconsDescription = () => {
    const {t} = useTranslation('common');

    return (
        <Box>
            <Typography variant="caption" sx={{ display: "flex", alignItems: "center", mt: toRem(8)}}>
                <AddIcon /> <span style={{marginLeft: toRem(8)}}>{t("zoom-in")}</span>
            </Typography>
            <Typography variant="caption" sx={{ display: "flex", alignItems: "center", mt: toRem(8)}}>
                <RemoveIcon/> <span style={{marginLeft: toRem(8)}}> {t("zoom-out")}</span>
            </Typography>
            <Typography variant="caption" sx={{ display: "flex", alignItems: "center", mt: toRem(8)}}>
                <Rotate90DegreesCcwIcon/>  <span style={{marginLeft: toRem(8)}}>{t("rotate-to-left")}</span>
            </Typography>
            <Typography variant="caption" sx={{ display: "flex", alignItems: "center", mt: toRem(8)}}>
                <UnfoldLessIcon/>  <span style={{marginLeft: toRem(8)}}>{t("revert-size")}</span>
            </Typography>
            <Typography variant="caption" sx={{ display: "flex", alignItems: "center", mt: toRem(8)}}>
                <FullscreenIcon/>  <span style={{marginLeft: toRem(8)}}>{t("fullscreen")}</span>
            </Typography>
        </Box>
    );
};

export default IconsDescription;